export const XIcon = ({
  color = "#0A0A0A",
  size = 24,
}: {
  color?: string;
  size?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M20.9467 6.98242L6.98145 20.9477"
        stroke={color}
        strokeWidth="2.32755"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.98145 6.98242L20.9467 20.9477"
        stroke={color}
        strokeWidth="2.32755"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
